module.exports = __webpack_public_path__ + "img/subscribe.9d238964.svg";